import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { TooltipPlacement, TooltipProps } from './types';

const placementClasses: Record<TooltipPlacement, string> = {
  top: 'tooltip-top',
  bottom: 'tooltip-bottom',
  left: 'tooltip-left',
  right: 'tooltip-right',
};

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ className, text, placement = 'top', children, ...props }, ref) => {
    const classes = twMerge('tooltip', placementClasses[placement], className);

    return (
      <div ref={ref} className={classes} data-tip={text} {...props}>
        {children}
      </div>
    );
  },
);

Tooltip.displayName = 'Tooltip';
